<template>
  <custom-popup
    v-model="internalDialog"
    :cons="translatedCons"
    :loading.sync="loading"
    hide-confirm
    max-width="800"
    transition="dialog-bottom-transition"
    scrollable
    reloadable
  >
    <template v-slot:extension>
      <v-tabs
        class="popup-tuts"
        v-model="internalTab"
        align-with-title
        grow
        background-color="transparent"
        dark
        color="primary"
        show-arrows
      >
        <v-tabs-slider />
        <v-tab v-for="(item, i) in translatedItemTitles" :key="i">
          <v-icon class="me-2">mdi-{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-tab>
      </v-tabs>
    </template>
    <v-card flat min-height="250">
            <v-tabs-items v-model="internalTab" class="pa-0 pa-md-4">
        <v-tab-item v-for="(tab, index) in translatedItemTitles" :key="index">
          
          <!-- تب جزئیات -->
          <template v-if="tab.title === $t('popup.details')">
            <v-card v-if="item && Object.keys(item).length > 0" flat>
              <v-card-title class="justify-content-center">
                {{ item.title || $t("popup.no_title") }}
              </v-card-title>
              
              <media-player
                ref="popupaudioPlayer"
                class="covermedia"
                v-if="item.audio"
                :src="item.audio"
                :type="'audio/mpeg'"
                :big="true"
              />

              <v-card-text class="pa-2 pa-md-4" v-if="item.text">
                <div
                  style="
                    white-space: pre-wrap; 
                    overflow-y: auto; 
                    max-height: 200px; 
                    line-height: 1.8; 
                    font-size: 1rem;
                  "
                >
                  {{ item.text }}
                </div>
              </v-card-text>

              <v-responsive aspect-ratio="16/9" v-if="item.images && item.images.length <= 2">
                <v-card class="mt-2 d-flex align-center justify-center">
                  <img
                    v-if="item.images.length === 1"
                    :src="item.images[0].url"
                    :alt="item.images[0].name || $t('popup.no_title')"
                    style="width: 100%; max-width: 100%; max-height: 400px; align-items: center;"
                    class="img"
                  />
                  <v-carousel
                    v-else-if="item.images.length === 2"
                    cycle
                    height="400"
                    hide-delimiter-background
                    show-arrows-on-hover
                  >
                    <v-carousel-item v-for="(image, i) in item.images" :key="i">
                      <img
                        :src="image.url"
                        :alt="image.name || $t('popup.no_title')"
                        style="width: 100%; max-width: 100%; max-height: 400px; align-items: center;"
                        class="img"
                      />
                    </v-carousel-item>
                  </v-carousel>
                </v-card>
              </v-responsive>

              <v-responsive aspect-ratio="16/9" v-if="item.videos && item.videos.length <= 2">
                <v-card class="mt-4">
                  <video-iframe
                    v-if="item.videos.length === 1"
                    ref="popupVideo"
                    controls
                    style="width: 100%; border-radius: 10px; height: 400px; box-sizing: border-box; background-color: black;"
                    loading="lazy"
                    :aria-placeholder="item.videos[0].name"
                    @error="handleVideoError"
                    :video="item.videos[0]"
                    :key-id="1"
                  ></video-iframe>
                  <v-carousel
                    v-else-if="item.videos.length === 2"
                    height="400"
                    show-arrows-on-hover
                    hide-delimiter-background
                  >
                    <v-carousel-item v-for="(video, i) in item.videos" :key="i">
                      <video-iframe
                        :key-id="i"
                        :video="video"
                        ref="popupVideo"
                        style="width: 100%; border-radius: 10px; height: 400px; box-sizing: border-box; background-color: black;"
                        :aria-placeholder="video.name"
                        @error="handleVideoError"
                      ></video-iframe>
                    </v-carousel-item>
                  </v-carousel>
                </v-card>
              </v-responsive>
              
              <v-card-text v-if="videoError" class="text-center" style="color: red">
                {{ $t("popup.video_error") }}
              </v-card-text>
            </v-card>

            <v-card v-else flat>
              <v-card-text class="text-center">
                {{ $t("popup.no_content") }}
              </v-card-text>
            </v-card>
          </template>

          <!-- تب عکس‌های راهنما -->
          <template v-else-if="tab.title === $t('popup.guide_images')">
            <v-card
              flat
              v-if="item && item.images && item.images.length > 2"
              class="mt-2 d-flex align-center justify-center"
            >
              <v-carousel cycle height="400" hide-delimiter-background show-arrows-on-hover>
                <v-carousel-item v-for="(image, i) in item.images" :key="i">
                  <img
                    :src="image.url"
                    :alt="image.name || $t('popup.no_title')"
                    style="width: 100%; max-width: 100%; max-height: 400px; align-items: center;"
                    class="img"
                  />
                </v-carousel-item>
              </v-carousel>
            </v-card>
          </template>

          <!-- تب ویدئوهای راهنما -->
          <template v-else-if="tab.title === $t('popup.guide_videos')">
            <v-card flat v-if="item && item.videos && item.videos.length > 2" class="mt-4">
              <v-responsive aspect-ratio="16/9">
                <v-carousel height="400" show-arrows-on-hover hide-delimiter-background>
                  <v-carousel-item v-for="(video, i) in item.videos" :key="i">
                    <video-iframe
                      ref="popupVideo"
                      controls
                      style="width: 100%; border-radius: 10px; height: 400px; box-sizing: border-box; background-color: black;"
                      loading="lazy"
                      :aria-placeholder="video.name"
                      @error="handleVideoError"
                      :video="video"
                    ></video-iframe>
                    <v-card-text v-if="videoError" class="text-center" style="color: red">
                      {{ $t("popup.video_error") }}
                    </v-card-text>
                  </v-carousel-item>
                </v-carousel>
              </v-responsive>
            </v-card>
          </template>

          <!-- تب سوالات متداول -->
          <template v-else-if="tab.title === $t('popup.faq')">
            <v-card flat>
              <v-expansion-panels flat>
                <v-expansion-panel
                  v-for="(itemExtras, i) in item.qa"
                  :key="i"
                  class="grey lighten-2 mb-2"
                >
                  <v-expansion-panel-header class="font-size-h4 font-weight-bold text-break">
                    {{ itemExtras.question || $t("popup.question_no_title") }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="pt-2 font-size-h6 text-break">
                    <div v-html="itemExtras.answer || $t('popup.no_answer')"></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-card-text v-if="!item.qa || item.qa.length === 0" class="text-center">
                {{ $t("popup.no_questions") }}
              </v-card-text>
            </v-card>
          </template>

        </v-tab-item>
      </v-tabs-items>

    </v-card>
  </custom-popup>
</template>

<script>
import customPopup from "../../../../../core/plugins/TitleRibbon/plugins/popup/customPopup.vue";
import MediaPlayer from "./MediaPlayer.vue";
import VideoIframe from "@/view/components/UploadCenter/videoUploader/videoIframe";

export default {
  name: "PopupContent",
  components: { customPopup, MediaPlayer, VideoIframe },
  props: {
    dialog: { type: Boolean, default: false },
    cons: { type: Object, default: () => ({ title: "راهنما" }) },
    loading: { type: Boolean, default: false },
    item: {
      type: Object,
      default: () => ({
        title: "",
        text: "",
        images: [],
        videos: [],
        qa: [],
        audio: null,
      }),
    },
    itemtitle: { type: Array, default: () => [] },
  },
  data() {
    return {
      videoError: false,
      internalTab: 0,
      internalDialog: this.dialog,
    };
  },
  computed: {
    translatedCons() {
      return {
        ...this.cons,
        title: this.cons.title || this.$t("popup.default_title"),
      };
    },
    translatedItemTitles() {
      return this.itemtitle.map((item) => ({
        ...item,
        title: this.translateTabTitle(item.title),
      }));
    },
  },
  watch: {
    dialog(newVal) {
      this.internalDialog = newVal;
      this.internalTab = 0; 
    },
    internalDialog(newVal) {
      this.$emit("update:dialog", newVal);
      if (!newVal) {
        this.stopMedia();
        this.internalTab = 0; // ریست تب هنگام بستن
      }
    },
    internalTab() {
      // توقف مدیا هنگام تغییر تب
      this.stopMedia();
    },
    loading(newVal) {
      this.$emit("update:loading", newVal);
    },
  },
  methods: {
    translateTabTitle(title) {
      const titleMap = {
        "جزئیات": "popup.details",
        "جزییات": "popup.details",
        "عکس‌های راهنما": "popup.guide_images",
        "ویدئوهای راهنما": "popup.guide_videos",
        "سوالات متداول": "popup.faq",
      };
      return this.$t(titleMap[title]) || this.$t(title);
    },
    handleVideoError() {
      this.videoError = true;
    },
stopMedia() {
  if (this.$refs.popupaudioPlayer?.isPlaying) {
    // اطمینان از وجود متد pause در پلیر صدا
    if (typeof this.$refs.popupaudioPlayer.$refs.audioPlayer?.pause === 'function') {
      this.$refs.popupaudioPlayer.$refs.audioPlayer.pause();
    }
    this.$refs.popupaudioPlayer.isPlaying = false;
  }
  
  if (this.$refs.popupVideo) {
    const videos = Array.isArray(this.$refs.popupVideo) ? this.$refs.popupVideo : [this.$refs.popupVideo];
    
    videos.forEach((video) => {
      if (video && typeof video.pause === 'function') {
        video.pause();
      } 
      else if (video && video.$el && typeof video.$el.pause === 'function') {
        video.$el.pause();
      }
    });
  }
},
  },
};
</script>

<style scoped>
.popup-tuts {
  max-width: calc(100% - 44px);
}
.v-tabs >>> .v-slide-group__prev,
.v-tabs >>> .v-slide-group__next {
  min-width: 36px;
}
.v-tabs >>> .v-tab:not(.v-tab--active),
.v-tabs >>> .v-tab:not(.v-tab--active) .v-icon {
  color: white !important;
}
.v-expansion-panel--active >>> .v-expansion-panel-header {
  background-color: var(--v-warning-base);
  min-height: 49px;
  transition: background-color 0.3s ease;
}
.v-expansion-panels :deep(.v-expansion-panel-header),
.v-expansion-panels :deep(.v-expansion-panel-content__wrap) {
  line-height: 1.3em;
}
.covermedia {
  max-width: unset;
  width: calc(100% - 32px);
  margin: 16px;
  justify-content: unset;
  border: 1px solid rgb(214, 212, 212);
}
.img {
  width: calc(100% - 32px);
  max-width: 100%;
  height: auto;
  object-fit: cover;
  margin: 16px;
  border-radius: 10px;
  transition: transform 0.3s ease;
  cursor: pointer;
}
.img:hover {
  transform: scale(1.09);
}
video {
  width: calc(100% - 32px);
  max-width: 100%;
  height: 400px;
  margin: 16px;
  border-radius: 10px;
  background-color: black;
  box-sizing: border-box;
}
.v-tabs-items {
  padding: 16px;
  min-height: 250px; /* جلوگیری از به‌هم‌ریختگی */
}
.v-card-text {
  padding: 16px !important;
}
.v-expansion-panels {
  padding: 0 16px;
}
@media (max-width: 600px) {
  .v-tabs-items {
    padding: 8px;
  }
  .v-card-text {
    padding: 8px !important;
  }
  .v-expansion-panels {
    padding: 0 8px;
  }
  .img,
  video,
  .covermedia {
    margin: 0 8px;
    width: calc(100% - 16px);
  }
}
</style>
